
















import '@/assets/scss/pages/app-todo.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ITask, TaskStatus } from 'admiral-core';
import TaskListViewItem from '@/views/pages/tasks2/TaskListViewItem.vue';
import { compareTasksByStatusOrder } from '@/utils/taskListOrder';

const STATUS_RANK: TaskStatus[] = [
  TaskStatus.TODO,
  TaskStatus.IN_PROGRESS,
  TaskStatus.IN_WAITING,
  TaskStatus.COMPLETED,
  TaskStatus.ARCHIVED,
];

function comparePolicyEmbedTasks(a: ITask, b: ITask): number {
  const ra = STATUS_RANK.indexOf(a.status);
  const rb = STATUS_RANK.indexOf(b.status);
  const sa = ra === -1 ? STATUS_RANK.length : ra;
  const sb = rb === -1 ? STATUS_RANK.length : rb;
  if (sa !== sb) return sa - sb;
  return compareTasksByStatusOrder(a, b);
}

@Component({
  name: 'PolicyEmbeddedTaskList',
  components: { TaskListViewItem },
})
export default class PolicyEmbeddedTaskList extends Vue {
  @Prop({ type: Array, required: true }) tasks!: ITask[];

  get displayTasks(): ITask[] {
    const list = Array.isArray(this.tasks) ? [...this.tasks] : [];
    list.sort(comparePolicyEmbedTasks);
    return list;
  }
}
